export default function receiveEntities(Entity, data) {
  return {
    type: `@@acast-resource/INJECT_MULTIPLE_${Entity.name.toUpperCase()}`,
    data,
  };
}
